import { render, staticRenderFns } from "./assignSet.vue?vue&type=template&id=a5eb5f50"
import script from "./assignSet.vue?vue&type=script&lang=js"
export * from "./assignSet.vue?vue&type=script&lang=js"
import style0 from "./assignSet.vue?vue&type=style&index=0&id=a5eb5f50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports